import { Component, OnInit, ViewChild } from '@angular/core';
import { NutricoesService } from './nutricoes.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AlertComponent } from "../../../alert/alert.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ListasService } from '../listas/listas.service';
import { CanaisServiceService } from '../canais/canais-service.service';
import { UserService } from '../services/user.service';
interface ClienteDeleteAttributes {
  idnutricao: number;
  idcliente: number;
  nome: string;
  uuid: string;
}


@Component({
  selector: 'app-nutricoes',
  standalone: true,
  imports: [CommonModule, MatIconModule, AlertComponent, LoadingModalComponent, ReactiveFormsModule],
  templateUrl: './nutricoes.component.html',
  styleUrls: ['./nutricoes.component.scss'],
  providers: [NutricoesService, ListasService, CanaisServiceService, UserService]
})
export class NutricoesComponent implements OnInit {

  //Variaveis de alerta e loading
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent !: LoadingModalComponent;

  private unsubscribe$ = new Subject<void>();

  //variaveis de listagem das nutricoes
  public listNutricoes!: Array<any>;
  public listCanais!: Array<any>;
  public nutricoesLiberadas: number = 0;
  public nutricoesCadastradas: number = 0;

  //Variaveis para insercao manual
  public formInsercaoManual: FormGroup;

  //Variaveis modal inserir via arquivo
  public modalImportFile: boolean = false;
  public fileName: string = '';
  public formCsv: FormGroup;

  //Variaveis para cadastrar nutricoes
  public modalCreateNutricao: boolean = false;
  public formCreateNutricao: FormGroup;

  //Variaveis para excluir nutricoes
  public modalDeleteNutricao: boolean = false;
  public selectedIndexClient!: number;
  public selectedNutricaoDelete!: ClienteDeleteAttributes;

  //Variaveis para cadastro de mensagens na nutricao
  public modalCadastrarMensagemNutricao: boolean = false;
  public formCadastrarMensagemNutricao!: FormGroup;

  //Variaveis para visualizar numeros em nutricao
  public modalVisualizarNumerosNutricao: boolean = false;
  public listNumbersInNutrition!: Array<any>;

  public unidadeMedidas = [
    {
      nome: 'Minutos',
      valor: '1'
    }, 
    {
      nome: 'Horas',
      valor: '2'
    },
    {
      nome: 'Dias',
      valor: '3'
    }
  ]

  //Variaveis para o modal de visualizar mensagens de uma nutricao
  public modalVisualizarMensagemNutricao: boolean = false;
  public listMessagesRegisteredInNutrition!: Array<any>;



  constructor(private nutricoesService: NutricoesService, private fb: FormBuilder) {
    this.formInsercaoManual = this.fb.group({
      numero: ['', [Validators.required, Validators.pattern(/^\(\d{2}\)\s?\d{4,5}-\d{4}$/), Validators.maxLength(15)]],
      idnutricao: [null, [Validators.required]],
      idcanal: [null, [Validators.required]]
    });

    this.formCsv = this.fb.group({
      fileCsv: [''],
      idnutricao: ['', [Validators.required]],
      idcanal: ['', [Validators.required]]
    });

    this.formCreateNutricao = this.fb.group({
      nome: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.nutricoesService.getAllNutricoes().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((response: any) => {
      this.listNutricoes = response.nutricoes
      this.nutricoesCadastradas = response.nutricoes.length
    }, (error: any) => {
      console.log(error);
    })
    this.nutricoesService.getCanais().subscribe((response: any) => {
      this.listCanais = response.canais;
    });
    this.nutricoesService.getConfigsUser().subscribe((response: any)=> {
      this.nutricoesLiberadas = response.configUser.quantidadeNutricao
    }, (error: any)=> {
      console.log(error);
    })

  }

  public trackByIdNutricoes(index: number, item: any): number {
    return item.id; // Identificador único
  }

  public trackByIdCanais(index: number, item: any): number {
    return item.id; // Identificador único
  }

  public copyCodeNutricao(code: string) {
    navigator.clipboard.writeText(code);
    this.alertComponent.showAlert('Codigo copiado com sucesso!', 'success');
  }

  //Funcoes para adicionar nutricao manualmente
  public onSubmit() {
    if (this.formInsercaoManual.invalid) {
      this.formInsercaoManual.markAllAsTouched();
      return;
    }
    this.loadingComponent.activeLoading();
    this.nutricoesService.addNutricaoManual(this.formInsercaoManual.value).subscribe((response: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Numero adicionado com sucesso a nutrição', 'success');
      this.formInsercaoManual.reset();
      this.updateDataNutricoes();
    }, (error: any)=>{
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao adicionar o numero a nutrição: ${error.error.status}`, 'error');
    })
   
  }

  public getListNutricao(){
    this.nutricoesService.getAllNutricoes().subscribe((response: any)=> {
      this.listNutricoes = response.nutricoes
    })
  }

  public updateDataNutricoes(){
    this.nutricoesCadastradas = this.listNutricoes.length;
    this.nutricoesCadastradas = this.listNutricoes.length;
  }

  //Funcoes do modal de importar arquivo
  public openModalImportFile() {
    this.modalImportFile = true;
  }

  public closeModalImportFile() {
    this.modalImportFile = false;
    this.fileName = '';
    this.formCsv.reset();
  }

  public onFileChange(event: Event) {
    const file = (event?.target as HTMLInputElement).files?.[0];
    if (file) {
      this.fileName = file.name;
      this.convertToBase64(file);
    }

  }

  private convertToBase64(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.formCsv.get('fileCsv')?.setValue(reader.result?.slice(21));
    };
    reader.readAsDataURL(file);
  }

  public deleteFileSelect() {
    this.fileName = '';
    this.formCsv.patchValue({
      fileCsv: ''
    });

    // Limpar o valor do input de arquivo para permitir reseleção do mesmo arquivo
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = ''; // Limpar o valor do input de arquivo
    }
  }

  public onSubmitCsv() {
    this.loadingComponent.activeLoading();
    this.nutricoesService.addNutricaoFile(this.formCsv.value).subscribe((response: any)=> {
      console.log(response);
      this.alertComponent.showAlert('Arquivo ativado na nutrição com sucesso', 'success');
      this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      console.log(error.error);
    })
  }

  //Funcoes para insercao manual
  public formatNumber() {
    const raw = (this.formInsercaoManual.value.numero || '').replace(/\D/g, '').slice(0, 11);
    if (!raw) {
      this.formInsercaoManual.patchValue({ numero: '' }, { emitEvent: false });
      return;
    }

    if (raw.length <= 2) {
      this.formInsercaoManual.patchValue({ numero: `(${raw}` }, { emitEvent: false });
      return;
    }

    const ddd = raw.slice(0, 2);
    const numero = raw.slice(2);

    const prefixo = numero.slice(0, 5);
    const sufixo = numero.slice(5, 9);

    const formatted = sufixo ? `(${ddd}) ${prefixo}-${sufixo}` : `(${ddd}) ${prefixo}`;

    this.formInsercaoManual.patchValue({ numero: formatted }, { emitEvent: false });
  }

  //Funcoes para criacao de nutricao

  public openModalCreateNutricao(){
    this.modalCreateNutricao = true;
  }

  public closeModalCreateNutricao(){ 
    this.formCreateNutricao.reset(); 
    this.modalCreateNutricao = false;
  }


  public onSubmitCreateNutricao(){
   this.loadingComponent.activeLoading();
    this.nutricoesService.setNutricao(this.formCreateNutricao.value).subscribe((response: any)=>{
      this.alertComponent.showAlert('Nutricao criada com sucesso!');
      this.loadingComponent.inactiveLoading();
      this.listNutricoes.push({uuid: '...', nome: this.formCreateNutricao.value.nome});
      this.closeModalCreateNutricao();
      this.getListNutricao();
      this.updateDataNutricoes();
    }, (error: any)=> { 
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao cadastrar nutrição: ${error.error.status}`, 'error');
    })
  }




  //Funcoes para deletar uma nutricao
  
  public openModalDeleteNutricao(indexNutricao: number): void{
    this.modalDeleteNutricao = true;
    this.selectedIndexClient = indexNutricao;
    this.selectedNutricaoDelete = this.listNutricoes[indexNutricao];
  }
  
  public closeModalDeleteNutricao(): void{
    this.modalDeleteNutricao = false;
  } 

  public deleteNutricao(){
    this.loadingComponent.activeLoading();
    this.nutricoesService.deleteNutricao(this.selectedNutricaoDelete.idnutricao).subscribe((response: any)=> {
      this.loadingComponent.inactiveLoading();
      this.closeModalDeleteNutricao();
      this.alertComponent.showAlert(`Nutrição deletada com sucesso!`);

      //Processamento assincrono
      this.listNutricoes.splice(this.selectedIndexClient,1 );
      this.getListNutricao();      
    }, (error: any)=> {
      this.closeModalDeleteNutricao();
      this.updateDataNutricoes();
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar deletar nutrição: ${error.error.status}`);
    })
  }


  /**
   * Funcoes para manipulacao do formulario de cadastrar mensagem em uma nutricao
   */

  public openModalCadastrarMensagemNutricao(idNutricao: number){
    this.modalCadastrarMensagemNutricao = true;
    this.formCadastrarMensagemNutricao = this.fb.group({
      idnutricao: idNutricao,
      message: ['', [Validators.required]],
      unidademedida: ['1', [Validators.required]],
      time: ['', [Validators.required]],
      buttons: ['', [Validators.required]]
    });
  }

  public closeModalCadastrarMensagemNutricao(){
    this.modalCadastrarMensagemNutricao = false;
  }

  public onSubmitCadastrarMensagemNutricao(){
    this.loadingComponent.activeLoading();

    this.nutricoesService.setMessageNutricao(this.formCadastrarMensagemNutricao.value).subscribe((response: any)=> {
      this.alertComponent.showAlert('Mensagem cadastrada com sucesso!', 'success');
      this.closeModalCadastrarMensagemNutricao();
      this.loadingComponent.inactiveLoading();
    },(error: any)=> {
      this.alertComponent.showAlert(`Erro ao cadastrar mensagem: ${error.error.status}`, 'error');
      this.loadingComponent.inactiveLoading();
    })
    
  }

  //The functions of modal visualization messages of nutritions
  public trackByIdMessages(index: number, idMessage: number): number{
    return index;
  }

  
  public openModalVisualizationMessagesOnNutrition(idNutricao: number){
    this.loadingComponent.activeLoading();
    this.nutricoesService.getMessagesRegistredOnNutrition(idNutricao).subscribe((response: any)=> {
      this.listMessagesRegisteredInNutrition = response.configNutricao;
      this.loadingComponent.inactiveLoading();
      this.modalVisualizarMensagemNutricao = true;
    }, (error: any)=> {
      console.log(error);
    })
    
  }


  public closeModalVisualizationMessagesOnNutrition(){
    this.modalVisualizarMensagemNutricao = false;
  }

  public deleteMessageInNutrition(indexMessage: number){
    this.loadingComponent.activeLoading();
    this.nutricoesService.deleteMessageRegistredInNutrition(this.listMessagesRegisteredInNutrition[indexMessage].id).subscribe((response: any)=> {
      this.alertComponent.showAlert('Mensagem deletada com sucesso!', 'success');
      this.listMessagesRegisteredInNutrition.splice(indexMessage, 1);
      this.loadingComponent.inactiveLoading();
    }, (error : any)=> {
      this.alertComponent.showAlert('Erro ao tentar deletar mensagem cadastrada!','error');
      this.loadingComponent.inactiveLoading();
    })
  }

  //Funcoes do modal de visualizar os numeros na nutricao 
  public trackByIndexNumbers(index: number, id: number ): number {
    return index;
  }


  public openModalVisualizarNumerosNutricao(idNutricao: number){
    this.loadingComponent.activeLoading();
    this.nutricoesService.getRastreioNumbersInNutrition(idNutricao).subscribe((response: any)=> {
      this.listNumbersInNutrition = response;
      this.modalVisualizarNumerosNutricao = true;
      this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      console.log(error);
      this.loadingComponent.inactiveLoading();
    })
  }

  public closeModalVisualizarNumerosNutricao(){
    this.modalVisualizarNumerosNutricao= false;
  }

  public deleteNumberInNutrition(indexNumber: number){
    this.loadingComponent.activeLoading();
    this.nutricoesService.deleteNumberInNutrition(this.listNumbersInNutrition[indexNumber].numero).subscribe((response: any)=> {
      this.listNumbersInNutrition.splice(indexNumber, 1);
      this.alertComponent.showAlert('Numero deletado com sucesso!', 'success');
      this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      console.log(error);
      this.loadingComponent.inactiveLoading();
    })
  }
}
